import React from 'react';
import { Row } from '@thd-olt-component-react/grid';
import { arrayOf, shape, string, bool } from 'prop-types';
import './info-guides.scss';
import { List, ListItem } from '@thd-olt-component-react/list';
import { DocumentList } from '../DocumentList/DocumentList';
import { AdditionalResourcesLink } from '../AdditionalResourcesLink/AdditionalResourcesLink';

export const InfoGuides = (props) => {
  const { additionalResources, channel, returnMessage, showReturnMessage } = props;
  const isDesktop = channel === 'desktop';
  const { infoAndGuides, diyProjects, installationAndRentals } = additionalResources;

  return (
    <Row className="info-guides-wrapper">
      <div id="more-info" className="info-guides">
        <h3 className="info-guides__additional-resource">Additional Resources</h3>
        {
          infoAndGuides.length > 0 && (
            <>
              <h4 className="info-guides__title">From the Manufacturer</h4>
              <DocumentList
                documents={infoAndGuides}
                returnMessage={returnMessage}
                showReturnMessage={showReturnMessage}
              />
            </>
          )
        }
        {
          installationAndRentals.length > 0 && (
            <>
              <h4 className="info-guides__title">Installation, Service &amp; Rentals </h4>
              <List className="document-list-wrapper">
                {installationAndRentals.map((rental) => (
                  <ListItem key={rental?.name}>
                    <AdditionalResourcesLink
                      name={rental?.name}
                      url={rental?.url}
                      contentType={rental?.contentType}
                    />
                  </ListItem>
                ))}
              </List>
            </>
          )
        }
        {
          diyProjects.length > 0 && (
            <>
              <h4 className="info-guides__title">DIY Projects &amp; Ideas </h4>
              <List className="document-list-wrapper">
                {diyProjects.map((project) => (
                  <ListItem key={project?.name}>
                    <AdditionalResourcesLink
                      name={project?.name}
                      url={project?.url}
                      contentType={project?.contentType}
                    />
                  </ListItem>
                ))}
              </List>
            </>
          )
        }
      </div>
    </Row>
  );
};

InfoGuides.displayName = 'InfoGuides';

InfoGuides.propTypes = {
  additionalResources: shape({
    infoAndGuides: arrayOf(shape({
      name: string,
      url: string
    })),
    diyProjects: arrayOf(shape({
      contentType: string,
      name: string,
      url: string
    })),
    installationAndRentals: arrayOf(shape({
      contentType: string,
      name: string,
      url: string
    })),
  }).isRequired,
  channel: string.isRequired,
  returnMessage: string,
  showReturnMessage: bool
};
InfoGuides.defaultProps = {
  returnMessage: '',
  showReturnMessage: false
};